<script lang="ts">
    import Button from "@components/button/Button.svelte"
    import ButtonIcon from "@components/button/ButtonIcon.svelte"
    import Icon from "@components/material/Icon.svelte"
    import type { MeditationItem } from "@utils/audiobook/audio-meditations"
    export let meditation: MeditationItem
    export let index: number
</script>

<li class="themed-box flex justify-between pl-3">
    <div class="flex items-center gap-2">
        {#if meditation.morning === true}
            <Icon icon="sunset" class="w-6" /> <span>Morning</span>
        {:else if meditation.morning === false}
            <Icon icon="moon" class="w-6" /> <span>Evening</span>
        {:else if meditation.alt}
            <span>Option {index + 1}</span>
        {:else}
            <span>Option {index + 1}</span>
        {/if}
    </div>

    <Button on:click>
        <ButtonIcon icon="speaker" /> Play
    </Button>
</li>
